import React from "react";
import ReportCard from "../../components/ui/ReportCard";
import total from "../../images/status-up.png";

export default function TotalDirectorate({ report }) {
  return <ReportCard src={total} text={report} title="Total Directorates" />;
}
